$(document).ready(function () {
    $(document).on('click', '.office-configurator__select-input__reset-filter-wrapper', function () {
        var parentClassSelectInput = $(this).closest('.office-configurator__select-input');
        var selectElement = parentClassSelectInput.find('select');
        selectElement.val(selectElement.find('option:first').val());
        selectElement.trigger('change');
    });
});